module.exports = __webpack_public_path__ + "media/images/online_review_pana-02c35adbf43ca417a78cade0a63b80c0.svg";